import { InputWithSelection as LibInputWithSelection } from '@gurupay/gp-ui-library';
import { Controller, useFormContext } from 'react-hook-form';

interface InputWithSelectionProps {
	options: { value: string; label: string }[];
	label?: string;
	inputName: string;
	selectorName: string;
	isDisabled?: boolean;
	className?: string;
	inputType?: string;
	onUserChange?: () => void;
}

const InputWithSelection = ({
	options,
	label,
	inputName,
	selectorName,
	isDisabled,
	className,
	inputType,
	onUserChange,
}: InputWithSelectionProps) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const errorMessage = (errors[inputName]?.message ?? errors[selectorName]?.message) as
		| string
		| undefined;

	return (
		<Controller
			control={control}
			name={inputName}
			render={({ field: inputField }) => (
				<Controller
					control={control}
					name={selectorName}
					render={({ field: selectorField }) => (
						<LibInputWithSelection
							className={className}
							error={errorMessage}
							id={inputName}
							inputClassName="text-right"
							inputType={inputType}
							inputValue={inputField.value}
							isDisabled={isDisabled}
							label={label}
							onBlur={inputField.onBlur}
							onInputChange={(val) => {
								inputField.onChange(val);
								onUserChange?.();
							}}
							onSelectionChange={(option) => {
								selectorField.onChange(option.value);
								onUserChange?.();
							}}
							options={options}
							selectedValue={selectorField.value}
						/>
					)}
				/>
			)}
		/>
	);
};

export default InputWithSelection;
